export enum SessionStorageType {
  mobileHeaderAppPromo = 'mobileHeaderAppPromo',
}

export class SessionStorage {
  private constructor() {}

  static getItem(key: SessionStorageType): any {
    return sessionStorage.getItem(key);
  }

  static setItem(key: SessionStorage, value: any) {
    sessionStorage.setItem(key.toString(), value);
  }

  static removeItem(key: SessionStorageType): any {
    return sessionStorage.removeItem(key);
  }

  static clear() {
    sessionStorage.clear();
  }
}
